export const FORTIOS_SCAN_COMMAND = `cnspec scan fortios --hostname <FORTIOS_DEVICE_IP> --token <TOKEN>`;
